﻿// inspired by https://github.com/phudak3/ckeditor5-emoji/
import { Plugin } from 'ckeditor5';
import { createDropdown } from 'ckeditor5';

import { createHeaderView } from './emoji/HeaderView';
import { createEmojiListView } from './emoji/EmojiListView';
import { createSearchView } from './emoji/SearchView';
import { createInfoView } from './emoji/InfoView';

// #toolbar-emojis
const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0ZM8 7a2 2 0 1 1 -2 2 2 2 0 0 1 2 -2Zm-1.16 7.16a1 1 0 0 1 1.39 0.29 4.49 4.49 0 0 0 7.54 0 1 1 0 1 1 1.68 1.1 6.51 6.51 0 0 1 -10.9 0 1 1 0 0 1 0.29 -1.39ZM16 11a2 2 0 1 1 2 -2 2 2 0 0 1 -2 2Z"></path>
</svg>`;

export default class Emoji extends Plugin {
    static get pluginName() { return "Emoji"; }

    init() {
        const editor = this.editor;
        const { t } = editor.locale;

        editor.ui.componentFactory.add('emoji', locale => {
            const toolbarItem = createDropdown(locale);
            if (parent.location.href.indexOf('Textcomponent') > -1) {
                toolbarItem.panelPosition = 'se';
            }

            let dropdownContent = null;

            toolbarItem.buttonView.set({
                label: t('Emoji'),
                withText: false,
                icon: svg,
                tooltip: t('Emoji'),
                class: 'ck-emoji'
            });

            toolbarItem.on('change:isOpen', (evt, name, value, oldValue) => {
                if (value === true && oldValue === false) {
                    if (dropdownContent === null) {
                        dropdownContent = {
                            // header with category dropdown
                            headerView: createHeaderView(locale),
                            // text search
                            searchView: createSearchView(locale),
                            // emoji list
                            listView: createEmojiListView(locale),
                            // info with name and unicode char, just like special characters
                            infoView: createInfoView(locale)
                        }

                        dropdownContent.headerView.on('execute', (evt) => {
                            dropdownContent.listView.fire('change:filterCategory', evt.source.emojiCategory);
                        });

                        dropdownContent.listView.on('execute', (evt, data) => {
                            editor.execute('input', { text: data.character });
                            editor.editing.view.focus();
                        });

                        toolbarItem.panelView.children.add(dropdownContent.headerView);
                        toolbarItem.panelView.children.add(dropdownContent.searchView);
                        toolbarItem.panelView.children.add(dropdownContent.listView);
                        toolbarItem.panelView.children.add(dropdownContent.infoView);

                        dropdownContent.searchView.delegate('change:searchExpression').to(dropdownContent.listView);

                        dropdownContent.listView.on('tileHover', (evt, data) => {
                            dropdownContent.infoView.set(data);
                        });
                    }

                    dropdownContent.listView.fire('change:filterCategory', dropdownContent.listView.categoryFilter || 'All');

                    dropdownContent.infoView.set({
                        'character': null,
                        'name': null
                    });
                }
            });

            return toolbarItem;
        });
    }
}
